import * as React from "react";
import { useNavigate } from "react-router";
import { Button, Typography } from "@mui/material";
import { useSnackbar } from "notistack";

import { LoadingButton } from "ui";

import { useDeleteMultiReportMutation } from "fond/api";
import { Folder } from "fond/types";
import { Modal } from "fond/widgets";

interface IProps {
  cityReportFolder: Folder;
  onClose(): void;
}

const DeleteCityReportModal: React.FC<IProps> = ({ cityReportFolder, onClose }: IProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [deleteMultiReport, { isLoading }] = useDeleteMultiReportMutation();

  /**
   * Callback function for the Create button within the modal actions
   */
  const handleOnClick = async (event: React.MouseEvent<EventTarget>) => {
    if (cityReportFolder.MultiReport?.ID) {
      try {
        await deleteMultiReport(cityReportFolder.MultiReport);
        enqueueSnackbar("The market lens report has been deleted");
        onClose();
        // Navigate to the updated folder
        if (cityReportFolder?.ParentID) {
          navigate(`/folders/${cityReportFolder?.ParentID}/`);
        }
      } catch (e) {
        enqueueSnackbar("Market lense report deletion failed. Please try again...");
      }
    }
  };

  return (
    <Modal
      open
      header="Delete this market lens report"
      data-testid="delete-city-planner-report-modal"
      content={
        <>
          <Typography>
            Are you sure you wish to delete the market lens report <strong>{cityReportFolder.MultiReport?.Name}</strong>?
          </Typography>
          <Typography>The report & all content within will be removed for all users.</Typography>
        </>
      }
      actions={
        <>
          <Button data-testid="delete-city-planner-report-cancel-button" color="primary" onClick={onClose} sx={{ marginRight: 1 }}>
            Cancel
          </Button>
          <LoadingButton data-testid="delete-city-planner-report-save-button" color="destructive" onClick={handleOnClick} loading={isLoading}>
            Delete
          </LoadingButton>
        </>
      }
    />
  );
};

export default DeleteCityReportModal;
